import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class IWGSharedService {
    isMyRateDirty = false;
    isQuestionDirty = false;
    iwgUserLinkStatus = false;
    HasWorkerProfile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    iwgfileuploadstatus: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    iwgfileattached: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    iwgfilefiledeleted: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    iwgfileattachedreset: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    AssignmentChange: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    selecttoupdateeor: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    selecttoupdateaorcompliance: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    workertitlecontractor: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    workerselecttoupdateaorcompliance: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    workerselecttoupdateeor: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    iwgfileuploaded: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    resetPasswordProgress: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    isDialogOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    isStateChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    isBlurredBg: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    assignmentStatusChange: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    constructor() {}
    setMyRateDirty(myRateDirty: boolean) {
      this.isMyRateDirty = myRateDirty;
    }
    setAssignmentQuestionDirty(questionDirty: boolean) {
        this.isQuestionDirty = questionDirty;
    }

    getAssignmentQuestionDirty() {
        return this.isQuestionDirty;
    }
    setIWGUserLinkStatus (iwgUserLinkStatus: boolean) {
        this.iwgUserLinkStatus = iwgUserLinkStatus;
    }

    getMyRateDirty() {
      return this.isMyRateDirty;
    }

    getIWGUserLinkStatus() {
      return this.iwgUserLinkStatus;
    }

    getNavigationURL(pathname) {
        var url = '';      
        if ((pathname.indexOf("myGuides") > 0 || pathname.indexOf("countryGuideDetail") > 0)) {
            url = '/myGuides'
        }
        if ((pathname.indexOf("assignments?service=2") > 0 || pathname.indexOf("countryGuideDetail") > 0)) {
            url = '/myGuides'
        }
        console.log('getNavigationURL: '+ url)
        return url;
    }

    getNavURL() {
        var URL = '';
        try {
            var arrFrames = parent.document.getElementsByTagName("IFRAME");
            console.log(arrFrames)           
            if (arrFrames != null && arrFrames.length > 0) {
                for (var frame = 0; frame <= 0; frame++) {
                    if (arrFrames[frame] != null) {
                        var i_outerHTML = arrFrames[frame].outerHTML;
                        if (i_outerHTML && i_outerHTML.indexOf('/myGuides?embed=1') > 0) {
                            URL = 'myGuides'
                        } else if (i_outerHTML && i_outerHTML.indexOf('/vendor-invoices?embed=1') > 0) {
                            URL = 'vendor-invoices'
                        }
                    }    
                }
            }
            return URL;
        }
        catch (ex) {
            console.log('IFRAME' + ex);
        }
    }

    getIsEmbed() {
        var dreferrer = document.referrer;//Current Request URL
        var host = window.location.host;//IQA or what ever CXP URL
        if (dreferrer !== null && dreferrer !== "") {
            var url = document.referrer;
            var referrer = url.match(/:\/\/(.[^/]+)/)[1];
            if (referrer !== host) {
                return true;
            }
        }

        try {
            
           var arrFrames = parent.document.getElementsByTagName("IFRAME");
           var isIframe = false;
            if (arrFrames != null && arrFrames.length > 0) {
                for (var frame = 0; frame <= 0; frame++) {
                    if (arrFrames[frame] != null) {
                        var i_outerHTML = arrFrames[frame].outerHTML;
                        if (i_outerHTML && i_outerHTML.toLowerCase().indexOf('/embed/render') > 0) {
                            isIframe = true;
                        }                        
                    }
                }
                return isIframe;
            }
        }
        catch (ex) {
            console.log('IFRAME' + ex);
        }


        return false;        
    }

    sendPostMessageToParentWindow(data) {
        if (this.getIsEmbed()) {
            var sourceText = "";
            var serviceText = "";

            switch (data.source) {
                case 1:
                    sourceText = "quote";
                    break;
                case 2:
                    sourceText = "assignment";
                    break;
                case 3:
                    sourceText = "invoice";
                    break;
                default:
                    sourceText = "";
                    break;
            }

            if (data.service == 1 && data.source != 3) {
                serviceText = "eor";
            } else if (data.service == 2 && data.source != 3) {
                serviceText = "aor";
            } else if (data.service == 3 && data.source != 3) {
                serviceText = "icc";
            } else if (data.service == 1 && data.source == 3) {
                serviceText = "";
            } else if (data.service == 2 && data.source == 3) {
                serviceText = "vendor";
            }
            console.log("Post message to parent window..| serviceText -> " + serviceText + " | sourceText -> " + sourceText + " | queryParams -> " + data.queryParams);
            parent.postMessage({ source: (serviceText + sourceText), queryParams: data.queryParams}, "*");
        }
    }

    //need to remove only for testing
    Test() {
        try {
            console.log('parent starts Shared')
            console.log(parent)
            console.log('parent ends Shared')
            var arrFrames = parent.document.getElementsByTagName("IFRAME");
            var isIframe = false;
            if (arrFrames != null && arrFrames.length > 0) {
                for (var frame = 0; frame <= 0; frame++) {
                    if (arrFrames[frame] != null) {
                        var i_outerHTML = arrFrames[frame].outerHTML;
                        if (i_outerHTML && i_outerHTML.toLowerCase().indexOf('/embed/render') > 0) {
                            isIframe = true;
                        }
                    }
                }
                return isIframe;
            }
        }
        catch (ex) {
            console.log('IFRAME' + ex);
        }
    }

    setCookie(name: string, value: string, expireDays: number, path: string = '') {
        let d: Date = new Date();
        d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
        let expires: string = `expires=${d.toUTCString()}`;
        let cpath: string = path ? `; path=${path}` : '';
        document.cookie = `${name}=${value}; ${expires}${cpath}`;
    }    

  }
